import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { RichEditorStoreContext } from '../contexts/StoreContext'
import { RichEditorStore } from '../store/interface'

export const useRichEditorStore: UseStore<RichEditorStore> = selector => {
  return useContextStore(RichEditorStoreContext, selector)
}

export const useRichEditorStoreApi = () => {
  return useContextStoreApi(RichEditorStoreContext)
}
